<template>
  <div class="word word--layout-color col-span-12 lg:col-span-4 shadow-md bg-gray-50 flex">
    <div class="w-1/3 flex items-center">
      <img :src="word.image" :alt="word.en" class="" />
    </div>

    <div class="p-2 space-y-1 w-2/3">
      <div v-if="word.ja">
        <span class="word__ja">{{ word.ja }}</span>
        <TextSpeak :text="word.ja" lang="ja" />
      </div>

      <div v-if="word.en">
        <router-link :to="{ path: `/tu-vung/${categorySlug}/${word.ja || word.en}` }" class="hover:underline">
          <span class="word__en">{{ word.en }}</span>
        </router-link>
        <TextSpeak :text="word.en" lang="en" />
      </div>

      <div v-if="word.vi">
        <span class="word__vi">{{ word.vi }}</span>
        <TextSpeak :text="word.vi" lang="vi" />
      </div>

      <div v-if="word.description_admin || word.description_vi" class="text-sm ml-auto w-12">
        <div class="link" @click="$emit('view-detail', word.id)">
          {{ $t('dictionary.detail') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import TextSpeak from '&/TextSpeak.vue'

  defineProps<{
    categorySlug: string
    word: object
  }>()
</script>
